<template>
  <section class="block-wrapper">
    <h2 v-if="heading">
      {{ heading }}
    </h2>
    <div class="content">
      <slot />
    </div>
  </section>
</template>
<script>
export default {
  props: {
    heading: {
      type: String,
      default: '',
    },
  },
};
</script>
<style lang="scss" scoped>

.block-wrapper {
  border: 1px solid $c-alto;
  display: flex;
  flex-direction: column;
}

h2 {
  align-items: center;
  background: $c-alabaster;
  display: flex;
  min-height: 80px;
  padding: 0 20px;
}

h2 {
  font-family: $f-graphie-semibold;
  font-weight: 600;
  margin: 0;
  text-transform: none;

  @include font-size(20px);
}

.content {
  display: flex;
  flex-grow: 1;
  width: 100%;
}
</style>
